import React from "react";
import { Upload } from "lucide-react";
import { cn } from "@/lib/utils/cn";

interface UploadGraphicCardProps {
  onClick?: () => void;
  className?: string;
}

export const UploadGraphicCard = ({ onClick, className }: UploadGraphicCardProps) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        "group flex h-full w-full flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 bg-white px-4 py-8 text-center transition-all duration-300 hover:border-gray-400 hover:shadow-md",
        className
      )}
    >
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-gray-500 transition-colors group-hover:border-gray-300 group-hover:text-gray-700">
        <Upload className="h-5 w-5" />
      </div>
      <h3 className="mb-1.5 text-sm font-semibold text-gray-900">
        Eigene Grafik hochladen
      </h3>
      <p className="max-w-[160px] text-xs leading-relaxed text-gray-500">
        Fertiges Design direkt posten.
      </p>
    </button>
  );
};
